// extracted by mini-css-extract-plugin
export default {"title_box":"DashboardTitle_title_box__e5L+0","title":"DashboardTitle_title__7dFf-","icon":"DashboardTitle_icon__4hW-C"};